//Layouts
Vue.component(
    'main-container',
    require('./components/layouts/MainContainer').default
);

Vue.component(
    'navbar-item',
    require('./components/layouts/NavbarItem').default
)

Vue.component(
    'subnav',
    require('./components/layouts/Subnav').default
);

Vue.component(
    'list-component',
    require('./components/ListComponent/ListComponent').default
)

Vue.component(
    'save-edit-cancel-buttons',
    require('./components/general_components/SaveEditCancelButtons').default
)

//Admin
Vue.component(
    'company-create-edit-page',
    require('./components/pages/admin/CompanyCreateEditPage').default
);
Vue.component(
    'user-create-edit-page',
    require('./components/pages/admin/UserCreateEditPage').default
);
Vue.component(
	'clone-company-form-modal',
	require('./components/modals/CloneCompanyFormModal').default
);

//Components
Vue.component(
    'svg-image',
    require('./components/general_components/SVGImage').default
);

Vue.component(
    'password-input',
    require('./components/general_components/PasswordInput').default
);


Vue.component(
    'content-header',
    require('./components/general_components/ContentHeader').default
);

Vue.component(
    'form-header-buttons',
    require('./components/forms/FormHeaderButtons').default
);


//Jobs

Vue.component(
    'job-index',
    require('./components/jobs/JobIndex').default
);

Vue.component(
    'job-index-search',
    require('./components/jobs/JobIndexSearch').default
);

Vue.component(
    'job-create-edit-page',
    require('./components/pages/JobCreateEditPage').default
);

Vue.component(
    'job-information-page',
    require('./components/pages/JobInformationPage').default
);

Vue.component(
    'weekly-sheets-page',
    require('./components/pages/WeeklySheetsPage').default
);

Vue.component(
    'job-people-page',
    require('./components/pages/JobPeoplePage').default
);

Vue.component(
    'operative-job-card',
    require('./components/jobs/OperativeJobCard').default
)

Vue.component(
    'snag-list-component',
    require('./components/jobs/SnagListComponent').default
)

Vue.component(
    'job-row-card',
    require('./components/jobs/JobRowCard').default
);

Vue.component(
    'initial-briefing-page',
    require('./components/pages/InitialBriefingPage').default
);

Vue.component(
    'timeline-page',
    require('./components/pages/TimelinePage').default
);

Vue.component(
    'snag-list-page',
    require('./components/pages/SnagListPage').default
);

Vue.component(
    'snag-list-show-page',
    require('./components/pages/SnagListShowPage').default
);

Vue.component(
    'snag-list-submission',
    require('./components/submissions/SnagListSubmission').default
);

Vue.component(
    'submission-page',
    require('./components/pages/SubmissionPage').default
);

Vue.component(
    'custom-form-submission',
    require('./components/submissions/CustomFormSubmission').default
)

Vue.component(
    'face-fit-test-submission',
    require('./components/submissions/FaceFitTestSubmission').default
)

Vue.component(
    'havs-tools-submission',
    require('./components/submissions/HavsToolsSubmission').default
)

Vue.component(
    'initial-briefing-submission',
    require('./components/submissions/InitialBriefingSubmission').default
)

Vue.component(
    'ncr-defect-submission',
    require('./components/submissions/NcrDefectSubmission').default
)

Vue.component(
    'ppe-register-submission',
    require('./components/submissions/PpeRegisterSubmission').default
)

Vue.component(
    'site-survey-inspection-report-submission',
    require('./components/submissions/SiteSurveyInspectionReportSubmission').default
)

Vue.component(
    'start-right-minutes-submission',
    require('./components/submissions/StartRightMinutesSubmission').default
)

Vue.component(
    'toolbox-talks-submission',
    require('./components/submissions/ToolboxTalksSubmission').default
)

Vue.component(
    'training-certificate-submission',
    require('./components/submissions/TrainingCertificateSubmission').default
)

Vue.component(
    'rams-submission',
    require('./components/submissions/RAMSSubmission').default
)

Vue.component(
    'job-forms-page',
    require('./components/pages/JobFormsPage').default
);

Vue.component(
    'profile-page',
    require('./components/pages/ProfilePage').default
)

Vue.component(
    'operative-profile-page',
    require('./components/pages/OperativeProfilePage').default
)

Vue.component(
	'company-forms-page',
	require('./components/pages/CompanyFormsPage').default
);

//Forms
Vue.component(
    'form-create-edit-page',
    require('./components/pages/FormCreateEditPage').default
);

Vue.component(
    'list-item',
    require('./components/ListComponent/ListItem').default
)

Vue.component(
    'quality-assurance-questionnaire-submissions',
    require('./components/pages/QualityAssuranceQuestionnaireSubmissions').default
)

Vue.component(
    'quality-assurance-questionnaire-sections',
    require('./components/pages/QualityAssuranceQuestionnaireSections').default
)

//Toolbox Talks
Vue.component(
    'toolbox-talk-create-edit-page',
    require('./components/pages/ToolboxTalkCreateEditPage').default
);

//Company
Vue.component(
    'settings-page',
    require('./components/pages/SettingsPage').default
);

Vue.component(
    'company-settings-page',
    require('./components/pages/CompanySettingsPage').default
);

Vue.component(
    'company-people-page',
    require('./components/pages/CompanyPeoplePage').default
);

Vue.component(
    'edit-people-page',
    require('./components/pages/EditPeoplePage').default
);

Vue.component(
    'clients-page',
    require('./components/pages/ClientsPage').default
);

Vue.component(
    'edit-site-page',
    require('./components/pages/EditSitePage').default
);

Vue.component(
	'company-index-page',
	require('./components/pages/admin/CompanyIndexPage').default
);


//ssow
Vue.component(
    'method-statement-create-edit-page',
    require('./components/pages/ssow/MethodStatementCreateEditPage').default
);

Vue.component(
    'fixing-create-edit-page',
    require('./components/pages/ssow/FixingCreateEditPage').default
);

Vue.component(
    'risk-create-edit-page',
    require('./components/pages/ssow/RiskCreateEditPage').default
);

Vue.component(
    'coshh-create-edit-page',
    require('./components/pages/ssow/CoshhCreateEditPage').default
);


Vue.component(
    'active-ssow-page',
    require('./components/pages/ssow/ActiveSsowPage').default
);

Vue.component(
	'pdf-settings-page',
	require('./components/pages/ssow/PDFSettingsPage').default
);

Vue.component(
	'global-settings-page',
	require('./components/pages/GlobalSettingsPage').default
);

//Changes
Vue.component(
    'generic-modal',
    require('./components/modals/GenericModal').default
);

Vue.component(
    'quality-assurance-questionnaire-create-edit-page',
    require('./components/pages/QualityAssuranceQuestionnaireCreateEditPage').default
);

Vue.component(
    "site-survey-inspection-create-edit-page",
    require("./components/pages/SiteSurveyInspectionCreateEditPage").default
);

// Settings Page Components
Vue.component(
    "week-work-days",
    require("./components/settings/WeekWorkDays").default
)
Vue.component(
    "edit-staff-modal",
    require("./components/modals/EditStaffModal").default
)

Vue.component(
    "holiday-breaks",
    require("./components/settings/HolidayBreaks").default
)

Vue.component(
    "flatpickr-calendar",
    require("./components/settings/FlatpickrCalendar").default
)

// matrix

Vue.component(
    "ppe-component",
    require("./components/operations/PpeComponent").default
)

// submittable form

Vue.component(
    "form-question-free-text",
    require("./components/forms/questions/FormQuestionFreeText").default
)
